import {
	CheckOngoingExportRequest,
	CheckOngoingExportResponse,
	LogViewResponse,
	RequestExportResponse,
} from '../../../types/asyncExport.types';
import api from '../api';

export const checkOngoingExport = async (
	request: CheckOngoingExportRequest
): Promise<CheckOngoingExportResponse> => {
	const response = await api.post('/async-jobs/check-ongoing', request);
	return response.data;
};

export const requestRestrictedPlanExport = async (params: {
	cycle_id?: number;
	company_area_id?: number;
}): Promise<RequestExportResponse> => {
	const queryParams = new URLSearchParams();
	if (params.cycle_id) {
		queryParams.append('cycle_id', params.cycle_id.toString());
	}
	if (params.company_area_id) {
		queryParams.append(
			'company_area_id',
			params.company_area_id.toString()
		);
	}

	const url = `/restricted-plan/export-csv${
		queryParams.toString() ? `?${queryParams.toString()}` : ''
	}`;
	const response = await api.get(url);
	return response.data;
};

export const requestConsensusExport = async (
	cycleId?: number
): Promise<RequestExportResponse> => {
	const url = `/consensus/export-csv${cycleId ? `?cycle_id=${cycleId}` : ''}`;
	const response = await api.get(url);
	return response.data;
};

export const requestCollaborationExport = async (params: {
	collaboration_type: 'planning' | 'marketing' | 'commercial';
	cycle_id?: number;
	company_area_id?: number;
}): Promise<RequestExportResponse> => {
	const queryParams = new URLSearchParams();
	queryParams.append('collaboration_type', params.collaboration_type);
	if (params.cycle_id) {
		queryParams.append('cycle_id', params.cycle_id.toString());
	}
	if (params.company_area_id) {
		queryParams.append(
			'company_area_id',
			params.company_area_id.toString()
		);
	}

	const url = `/collaboration/export-csv?${queryParams.toString()}`;
	const response = await api.get(url);
	return response.data;
};

export const getLogView = async (params: {
	page?: number;
	size?: number;
	pagination?: {
		order?: Array<[string, 'ASC' | 'DESC']>;
	};
}): Promise<LogViewResponse> => {
	const response = await api.post('/log/view', {
		page: params.page || 1,
		size: params.size || 10,
		pagination: params.pagination || {
			order: [['data_hora', 'DESC']],
		},
	});
	return response.data;
};
